import { css, html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import type { Commerce, CommerceCustomerSession } from "@teqtank/commerce-sdk";
@customElement("teqtank-customer-status")
export class TeqtankCustomerStatus extends LitElement {
    @property({ attribute: false }) public accessor commerce: Commerce | undefined;
    @state() private accessor session: CommerceCustomerSession | undefined;
    private unsubscribe: (() => void) | undefined;
    static override styles = css`
        :host {
            display: inline-flex;
            font-family: Inter, ui-sans-serif, system-ui, sans-serif;
        }
        .status {
            display: inline-flex;
            align-items: center;
            gap: 0.55rem;
        }
        .avatar {
            display: grid;
            place-items: center;
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            background: var(--teqtank-color-surface-soft, #f7f4ee);
            font-size: 0.75rem;
            font-weight: 800;
        }
        .name {
            font-weight: 700;
        }
    `;
    override connectedCallback() {
        super.connectedCallback();
        this.bind();
    }
    protected override updated(changed: Map<PropertyKey, unknown>) {
        if (changed.has("commerce")) this.bind();
    }
    override disconnectedCallback() {
        this.unsubscribe?.();
        super.disconnectedCallback();
    }
    protected override render() {
        const s = this.session ?? this.commerce?.customer.session;
        return s?.status === "authenticated" && s.customer
            ? html`<span class="status"
                  ><span class="avatar">${s.customer.initials}</span
                  ><span class="name">${s.customer.displayName}</span></span
              >`
            : html`<span class="status">Guest</span>`;
    }
    private bind() {
        this.unsubscribe?.();
        this.unsubscribe = undefined;
        if (!this.commerce) return;
        this.session = this.commerce.customer.session;
        this.unsubscribe = this.commerce.customer.onChanged((e) => (this.session = e.session));
    }
}
declare global {
    interface HTMLElementTagNameMap {
        "teqtank-customer-status": TeqtankCustomerStatus;
    }
}
